import jQuery from 'jquery';

export default class BetslipInteracter {
    constructor() {
        this.onBookmakerChanged = this.onBookmakerChanged.bind(this);
        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
        this.setBetslipBookmaker = this.setBetslipBookmaker.bind(this);
        this.init = this.init.bind(this);
        this.decimalOdds = false;
    }

    init(feedName) {
        const deferred = jQuery.Deferred();
        this.resolvePromise = deferred.resolve;
        const customizeSettingsCookie = jQuery.cookie('customizeSettings');
        if (customizeSettingsCookie) {
            const customizeSettings = JSON.parse(customizeSettingsCookie);
            this.decimalOdds = customizeSettings.decimalOdds;
        }
        this.bindEvents();
        if (feedName) {
            this.feedName = feedName;
            this.setBetslipBookmaker(feedName);
        } else {
            this.requestSelectedBookmaker();
        }
        return deferred.promise();
    }

    onBookmakerChanged({ detail: { bookmaker } }) {
        jQuery(document).trigger('bookieChanged.BOOKMAKER', bookmaker);
        this.resolveBookmaker(bookmaker);
    }

    resolveBookmaker(bookmaker) {
        if (this.resolvePromise) {
            this.resolvePromise(bookmaker);
            this.resolvePromise = null;
            delete this.resolvePromise;
        }
    }

    onBetslipInitialized() {
        if (this.feedName) {
            this.setBetslipBookmaker(this.feedName);
            this.resolveBookmaker(this.feedName);
        } else {
            this.requestSelectedBookmaker();
        }
    }

    /* eslint-disable class-methods-use-this */
    requestSelectedBookmaker() {
        const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.GET');
        document.dispatchEvent(betslipEvent);
    }

    setBetslipBookmaker(bookmaker) {
        const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
            detail: { bookmaker },
        });
        document.dispatchEvent(betslipEvent);
    }
    /* eslint-enable class-methods-use-this */

    bindEvents() {
        document.addEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
        document.addEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
        document.addEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
    }

    destroy() {
        document.removeEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
        document.removeEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
        document.removeEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
    }
}




// WEBPACK FOOTER //
// ./src/js/shared/price/BetslipInteracter.js